import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { routes } from '@/shared/routes';

export default function Logo() {
  return (
    <Link to={routes.app.root} className="flex min-w-0 items-center gap-4">
      <div className="relative">
        <div className="h-12 w-12 overflow-hidden rounded-full shadow-xl shadow-slate-900/20">
          <img src="/logo.svg" alt="Skip Visa Queue" className="h-full w-full object-cover" />
        </div>
        <span className="absolute -bottom-0 -right-3 rounded-full bg-accent-300 px-1.5 py-0.5 text-[8px] font-medium uppercase tracking-[0.15em] text-slate-700 shadow">
          <FormattedMessage id="nav.liveStatus" />
        </span>
      </div>
      <div className="min-w-0 max-w-[5rem] sm:max-w-none">
        <p className="text-xs font-semibold uppercase tracking-[0.1em] sm:tracking-[0.15em] text-slate-400">
          <FormattedMessage id="nav.subtitle" />
        </p>
      </div>
    </Link>
  );
}
